export default {
  primary: '#0D342D',
  primaryWTrans: '#0D342D1A',

  shared: '#3EB579',
  logo: '#D2FFE4',
  iceberg: '#EBF7F1',
  icebergWTrans: '#EBF7F180',
  greenPea: '#195F53',
  greenPeaHover: '#33796D',

  yellow: '#F2D022',
  tan: '#FFF9DA',
  blue: '#6EDAF2',

  darkGreen: '#0A342D',
  darkGreenHover: '#53877E',

  greenLight: '#98D3B6',
  greenLightHover: '#B2EDD0',
  yellowLight: '#F1E08A',
  blueLight: '#B0E6F2',

  danger: '#EE5C3D',
  lightDanger: '#FEF1F1',
  dangerWTrans: '#EE5C3D80',

  white: '#ffffff',
  black: '#000000',
  boulder: '#787878',
  boulderWTrans: '#78787880',
  darkGray: '#333333',
  focusBorderGray: '#00000055',
  gray: '#cacaca',
  lightGray: '#EBEBEB',
  background: '#f5f5f5',
  grayV: {
    50: '#f2f2f2',
    100: '#d9d9d9',
    200: '#bfbfbf',
    300: '#a6a6a6',
    400: '#8c8c8c',
    500: '#737373',
    600: '#595959',
    700: '#404040',
    800: '#262626',
    900: '#0d0d0d'
  }
};
